import Color from './color/Index.vue'
export default Color
